import { Factory, trait } from 'miragejs';
import { addDays, startOfToday } from 'date-fns';

export default Factory.extend({
  registrationDates: () => {
    return [];
  },

  withAnEmptyMonth: trait({
    afterCreate(employeeRegistration, server) {
      employeeRegistration.registrationDates = Array(...Array(30))
        .map((_, i) => addDays(startOfToday(), i))
        .map((date) =>
          server.create('graphql/registration-date', 'withSelfCertify', {
            employeeRegistration,
            date,
            hasRequiredDocumentApproval: false,
          })
        );
    },
  }),

  withAnEmptyMonthAndExpiredDocument: trait({
    afterCreate(employeeRegistration, server) {
      employeeRegistration.registrationDates = Array(...Array(30))
        .map((_, i) => addDays(startOfToday(), i))
        .map((date) =>
          server.create('graphql/registration-date', 'withSelfCertify', {
            employeeRegistration,
            date,
            hasRequiredDocumentApproval: false,
            requiredDocumentApprovalExpiresAt: null,
          })
        );
    },
  }),

  withAFullyBookedMonth: trait({
    afterCreate(employeeRegistration, server) {
      employeeRegistration.registrationDates = Array(...Array(30))
        .map((_, i) => addDays(startOfToday(), i))
        .map((date) =>
          server.create('graphql/registration-date', 'withDeskReservation', {
            employeeRegistration,
            date,
          })
        );
    },
  }),

  withAllDenials: trait({
    afterCreate(employeeRegistration, server) {
      employeeRegistration.registrationDates = Array(...Array(30))
        .map((_, i) => addDays(startOfToday(), i))
        .map((date) => server.create('graphql/registration-date', 'withDeniedInvite', { employeeRegistration, date }));
    },
  }),

  withAnEmpty2Weeks: trait({
    afterCreate(employeeRegistration, server) {
      employeeRegistration.registrationDates = Array(...Array(14))
        .map((_, i) => addDays(startOfToday(), i))
        .map((date) => server.create('graphql/registration-date', 'withSelfCertify', { employeeRegistration, date }));
    },
  }),

  // withNothingScheduledToday: trait({
  //   afterCreate(employeeRegistration, server) {
  //     const registrationDate = server.create('graphql/registration-date', 'withSelfCertify', { date: moment() });
  //     employeeRegistration.registrationDates = [registrationDate];
  //   },
  // }),

  // withDeskReservationToday: trait({
  //   afterCreate(employeeRegistration, server) {
  //     const registrationDate = server.create('graphql/registration-date', 'withDeskReservation', {
  //       date: moment(),
  //     });
  //     employeeRegistration.registrationDates = [registrationDate];
  //   },
  // }),

  // withInviteToday: trait({
  //   afterCreate(employeeRegistration, server) {
  //     const registrationDate = server.create('graphql/registration-date', 'withInvite', { date: moment() });
  //     employeeRegistration.registrationDates = [registrationDate];
  //   },
  // }),

  // withRegisteredInviteToday: trait({
  //   afterCreate(employeeRegistration, server) {
  //     const registrationDate = server.create('graphql/registration-date', 'withRegisteredInvite', { date: moment() });
  //     employeeRegistration.registrationDates = [registrationDate];
  //   },
  // }),

  // withEntryAndReservationToday: trait({
  //   afterCreate(employeeRegistration, server) {
  //     const registrationDate = server.create('graphql/registration-date', 'withEntryAndDeskReservation', {
  //       date: moment(),
  //     });

  //     employeeRegistration.registrationDates = [registrationDate];
  //   },
  // }),

  // withEntryAndNoReservationToday: trait({
  //   afterCreate(employeeRegistration, server) {
  //     const registrationDate = server.create('graphql/registration-date', 'withEntryNoDeskReservation', {
  //       date: moment(),
  //     });

  //     employeeRegistration.registrationDates = [registrationDate];
  //   },
  // }),
});
